<ion-header class="modalHeader">
  <ion-toolbar mode="ios">
    <ion-title>Recherche de site</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-input
    #query
    fill="outline"
    [autofocus]="true"
    type="text"
    [placeholder]="'choixSite.searchPlaceholder' | translate"
    [(ngModel)]="queryText"
    (ionInput)="onQueryChange($event.target.value)"
  ></ion-input>
</ion-header>
<ion-content class="ion-padding offset-container">
  @if (isLoading()) {
    <div class="spinner-wrapper">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  }

  @if (queryText) {
    @for (site of sitesResult(); track site) {
      <ion-button class="result ion-no-margin ion-align-items-start" expand="block" color="light" (click)="chooseSite(site)">
        {{ site.libelle }}
      </ion-button>
    }
  } @else {
    Entrez le nom d'un site
  }
</ion-content>
